// extracted by mini-css-extract-plugin
export default {"header":"tariff-select_header__ecsdX","title":"tariff-select_title__5YOpB"};